module.exports = __webpack_public_path__ + "static/media/white_tick.8551a7f1.svg";